module.exports = __webpack_public_path__ + "img/icon9.04e71060.svg";